'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'find_booking',

    viewClass: require('./view'),

    methods: {
        renderTemplate(data) {
            this.renderTemplate(data);
        },

        emptyFindBookings() {
            this.emptyFindBookings();
        },
    },
});
